var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ModalDetail'),_c('ModalCategories'),_c('ModalConfirm'),_c('ModalReport'),_c('ModalInputSave')],1)}
var staticRenderFns = []

export { render, staticRenderFns }